var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeatBooked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "seat-booked_svg__a",
    d: "M.076 2.229c0-1.21.994-2.192 2.222-2.192h9.774c1.227 0 2.222.981 2.222 2.192v9.07c0 1.21-.994 2.192-2.222 2.192H2.298c-1.227 0-2.222-.981-2.222-2.192V2.23z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 8.542 8.041)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "seat-booked_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#seat-booked_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    stroke: "#8F908C",
    strokeWidth: 0.75,
    d: "M2.298.037h9.774c1.227 0 2.222.981 2.222 2.192v9.07c0 1.21-.994 2.192-2.222 2.192H2.298c-1.227 0-2.222-.981-2.222-2.192V2.23c0-1.21.994-2.192 2.222-2.192z",
    mask: "url(#seat-booked_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C7C7C2",
    d: "M14.55 3.736H8.113a.608.608 0 01-.614-.6V1.184c0-.332.275-.6.614-.6h8.772c.339 0 .614.268.614.6v15.59-.007.216c0 .332-.275.6-.614.6H8.114a.607.607 0 01-.614-.6v-1.952c0-.331.275-.6.614-.6h6.435V3.736z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#7C7E7A",
    strokeWidth: 0.75,
    d: "M14.55 3.736H8.113a.608.608 0 01-.614-.6V1.184c0-.332.275-.6.614-.6h8.772c.339 0 .614.268.614.6v15.59-.007.216c0 .332-.275.6-.614.6H8.114a.607.607 0 01-.614-.6v-1.952c0-.331.275-.6.614-.6h6.435V3.736z"
  }))));
}
export default SvgSeatBooked;